export const fixTextAfterWikiMarkupTransformation = (text: string) => {
  return text
    .replace(/\\+(\[~accountId:.*?\])/gi, '$1')
}
